import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { routing } from './app.routing';
import { LayoutModule } from './layout/layout.module';
import { SharedService } from './layout/shared/shared.service';
import { CommunicationService } from './layout/shared/communication.service';
import { LoaderService } from './layout/shared/loader.service';
import { LayoutComponent } from './layout/layout.component';
import { AuthGuardService } from './authentication/auth-guard.service';
import { AuthService } from './authentication/auth.service';
import { AuthCallbackComponent } from './authentication/auth-callback/auth-callback.component';
import { MenuModule } from './layout/menu/menu.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { registerLocaleData } from '@angular/common';
import localeGB from '@angular/common/locales/en-GB';
import {CanDeactivateGuard } from './layout/core/can-deactivate-guard.service';

registerLocaleData(localeGB, 'en-GB');

@NgModule({
  declarations: [
    AppComponent, LayoutComponent, AuthCallbackComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    routing,
    LayoutModule,
    MenuModule.forRoot(),
  ],
  providers: [SharedService, CommunicationService, LoaderService, AuthGuardService, AuthService,CanDeactivateGuard,
  // { provide: LOCALE_ID, deps: [SharedService], useFactory: (sharedfunc) }
  { provide: LOCALE_ID, useFactory: (shServ:SharedService)=>shServ.globalInfo().Culture,deps: [SharedService] }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }